import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getEmpresas,
  deleteEmpresa,
  getEmpresaById,
} from "../helpers/rutaEmpresas";
import ModalEmpresa from "./ModalEmpresa";
import "../css/tableclientes.css";

const TableEmpresas = () => {
  const [state, setState] = useState({
    data: [],       // ← siempre array para .map
    loading: true,
    error: null,
  });

  const [empresa, setEmpresa] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaEmpresas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const normalizarLista = (resp) => {
    // Soporta: resp = []  ó  resp = { empresas: [], cantidad }
    const list = Array.isArray(resp)
      ? resp
      : Array.isArray(resp?.empresas)
      ? resp.empresas
      : [];
    return list;
  };

  const consultaEmpresas = async () => {
    try {
      const resp = await getEmpresas();
      const list = normalizarLista(resp);
      setState({ data: list, loading: false, error: null });
      console.log("📦 Empresas:", list);
    } catch (e) {
      console.error("❌ getEmpresas ERROR:", e);
      setState((s) => ({ ...s, loading: false, error: e?.message || "Error cargando empresas" }));
    }
  };

  const handleClose = () => {
    setShow(false);
    consultaEmpresas();
  };

  const handleShow = () => setShow(true);

  const modificaEmpresa = async (id) => {
    try {
      const resp = await getEmpresaById(id);
      // Soporta: { ok, empresa }  ó  el doc directo
      const doc = resp?.empresa ?? resp;
      if (!doc) throw new Error("Empresa no encontrada");
      setEmpresa(doc);
      handleShow();
    } catch (e) {
      console.error("❌ Error al obtener empresa:", e);
      alert("No se pudo obtener la empresa.");
    }
  };

  const eliminarEmpresa = async (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar la empresa?");
    if (!confirmar) return;
    try {
      await deleteEmpresa(id);
      await consultaEmpresas();
    } catch (e) {
      console.error("❌ Error al borrar empresa:", e);
      alert("No se pudo borrar la empresa.");
    }
  };

  const { data, loading, error } = state;

  return (
    <div className="table-container">
      {loading && <div className="mt-3">Cargando empresas…</div>}
      {!loading && error && <div className="mt-3 text-danger">Error: {error}</div>}

      {!loading && !error && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Empresa</th>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan={3} className="text-center">
                      Sin empresas
                    </td>
                  </tr>
                ) : (
                  data.map((empresa) =>
                    empresa?.activo ? (
                      <tr key={empresa._id}>
                        <td>
                          <button
                            className="btn btn-primary"
                            onClick={() => modificaEmpresa(empresa._id)}
                            title="Editar"
                          >
                            <i className="fa fa-pencil-square-o" aria-hidden="true" />
                          </button>
                          <button
                            className="btn btn-danger ml-2"
                            onClick={() => eliminarEmpresa(empresa._id)}
                            title="Eliminar"
                          >
                            <i className="fa fa-trash-o" aria-hidden="true" />
                          </button>
                        </td>
                        <td>{empresa.codemp ?? "-"}</td>
                        <td>{empresa.empresa ?? empresa.razonSocial ?? "-"}</td>
                      </tr>
                    ) : null
                  )
                )}
              </tbody>
            </Table>
          </div>

          <ModalEmpresa show={show} handleClose={handleClose} empresa={empresa} />
        </>
      )}
    </div>
  );
};

export default TableEmpresas;
